import { render } from "./IniziaRilevazione.vue?vue&type=template&id=4e1512ca&scoped=true"
import script from "./IniziaRilevazione.vue?vue&type=script&lang=js"
export * from "./IniziaRilevazione.vue?vue&type=script&lang=js"

import "./IniziaRilevazione.vue?vue&type=style&index=0&id=4e1512ca&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1512ca"]])

export default __exports__